import { render, staticRenderFns } from "./CourseStudentList.vue?vue&type=template&id=0516ecfe&"
import script from "./CourseStudentList.vue?vue&type=script&lang=ts&"
export * from "./CourseStudentList.vue?vue&type=script&lang=ts&"
import style0 from "./CourseStudentList.vue?vue&type=style&index=0&id=0516ecfe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports